import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=4a480c80&"
import script from "./Admins.vue?vue&type=script&lang=ts&"
export * from "./Admins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports